import en from './translations/en.json'
import de from './translations/de.json'
import hr from './translations/hr.json'

export default {
    en, de, hr
}


// WEBPACK FOOTER //
// ./src/lang/index.js